var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 40.25C10.5938 56.7668 23.9832 70.1563 40.5 70.1563C57.0168 70.1563 70.4063 56.7668 70.4063 40.25C70.4063 23.7332 57.0168 10.3438 40.5 10.3438C23.9832 10.3438 10.5938 23.7332 10.5938 40.25Z",
    fill: "#08C108"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4688 33.6042L37.1771 46.8958L30.5313 40.25M40.5 70.1563C23.9832 70.1563 10.5938 56.7668 10.5938 40.25C10.5938 23.7332 23.9832 10.3438 40.5 10.3438C57.0168 10.3438 70.4063 23.7332 70.4063 40.25C70.4063 56.7668 57.0168 70.1563 40.5 70.1563Z",
    stroke: "white",
    strokeWidth: 3.32292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/Greentick.23a370de5a45bfdc8c6f8acef6f27dca.svg";
export { ForwardRef as ReactComponent };